export const AgendaTypesEnum = {
    Categories: "categories",
    Taxation: "taxation",
    Pricing: "pricing",
    Locations: "locations",
    Assignments: "assignments",
    Customers: "customers",
    CustomersFeedback: "customersFeedback",
    transactionsReport: "transactionsReport",
    Cash: "cash",
    Orders: "orders",
    Schematized: "schematized",
    SummaryReport: "summaryReport",
    ExtensiveReports: "extensiveReports",
    SalesByItems: "salesByItems",
    SpecialPricing: "specialPricing",
    SalesByModifiers: "salesByModifiers",
    SalesByModifierGroups: "salesByModifierGroups",
    Timesheet: "timesheet",
    Roles: "roles",
    Settings: "settings",
}

export type AgendaTypes = (typeof AgendaTypesEnum)[keyof typeof AgendaTypesEnum]

export type AddTypes =
    | null
    | "category"
    | "product"
    | "option-group"
    | "modifier"
    | "modifier-group"
    | "pricing"
    | "tax"
    | "assignment"
    | "customers"
    | "role"

export type ModalTypes = null | "add-option" | "add-tax" | "add-option" | "location" | "terminal" | "role"
